import $ from 'jquery';

export default class TeamListing {
    constructor() {
        if ($('.js-team-listing').length) {
            if(Foundation.MediaQuery.is('small only')) {
                $('.js-team-listing__toggle').on('click', function() {
                    const $parent = $(this).closest('.js-team-listing');

                    $parent.find('.js-team-listing__people').slideToggle();
                    $parent.toggleClass('is-active');
                });
            };
        };
    };
};
